import { MantineTheme, rem } from '@mantine/core'

// Layout constants for XL+ breakpoints
export const LAYOUT_CONSTANTS = {
  SIDEBAR_WIDTH: 120,
  TOTAL_SIDEBAR_WIDTH: 240, // Both left and right sidebars
  MAIN_CONTENT_MAX_WIDTH: 1280,
  CONTENT_AREA_WIDTH: 1040, // MAIN_CONTENT_MAX_WIDTH - TOTAL_SIDEBAR_WIDTH
  BASE_HEADER_HEIGHT: 112
} as const

export const commonModalOverlayProps = (theme: MantineTheme) => ({
  color: /*theme.colorScheme === 'dark' ? theme.colors.grey[9] : */ theme.colors.gray[2],
  opacity: 0.55,
  blur: 3,
  zIndex: 1100
})

export const commonModalStyles = (theme: any) => ({
  modalHeader: {
    padding: `${rem(16)} ${rem(24)}`,
    borderBottom: `${rem(1)} solid ${theme.colors.gray[2]}`
  },
  modalBody: {
    padding: `${rem(24)} ${rem(24)}`
  },
  modalFooter: {
    padding: `${rem(16)} ${rem(16)}`,
    borderTop: `${rem(1)} solid ${theme.colors.gray[2]}`
  }
})
